import { render, staticRenderFns } from "./OverdueSaleTableRow.vue?vue&type=template&id=405b0bae&"
import script from "./OverdueSaleTableRow.vue?vue&type=script&lang=ts&"
export * from "./OverdueSaleTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports